/**
 * Prefer API host env over UI hostname — local UI can still hit prod DB.
 * Kept in sync with apps/admin environment-banner helpers.
 */
export function pickApiEnvironmentName(payload: unknown): string | null {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const record = payload as Record<string, unknown>;
  const value =
    (record as { BestGuess?: unknown }).BestGuess ??
    (record as { bestGuess?: unknown }).bestGuess ??
    (record as { Environment?: unknown }).Environment ??
    (record as { environment?: unknown }).environment ??
    (record as { Utils?: unknown }).Utils ??
    (record as { utils?: unknown }).utils;

  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  return value.trim();
}

/**
 * Banner for which Trakly API/DB the UI is talking to.
 * Hidden only when the deployed UI is production and the API is production.
 */
export function resolveEnvironmentBannerLabel(
  apiEnvironment: string | null,
  frontendProduction: boolean
): string | null {
  if (!apiEnvironment) {
    return null;
  }

  const normalized = apiEnvironment.trim().toUpperCase();
  if (!normalized) {
    return null;
  }

  if (frontendProduction && normalized === 'PRODUCTION') {
    return null;
  }

  return normalized + ' DATABASE';
}

export function isProductionEnvironmentBanner(label: string | null): boolean {
  return !!label && label.indexOf('PRODUCTION') === 0;
}
